import React, { useCallback, useState, useEffect, useContext } from 'react';

import PbxContext from '../../context/PbxContext';
import '../../libs/bulma.min.css';
import './styles.css';

import { exportSelectAllQueues, accessLocalStorage } from '../../services';
import { scopeByTenant } from '../../services/tenantScope';
import QueueList from '../../components/Events/QueueList';


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faFilter, faSync } from '@fortawesome/free-solid-svg-icons';
import QueueAgents from '../../components/Queues/QueueAgents';

function QueueEvents() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsHidden, toggleIsChangeFormElements } = getItensStateGlobal;
  
  const [ queues, setQueues] = useState([]);
  const [ queuesSelected, setQueuesSelected] = useState([]);
  const [ queuesSelectedAwaiting, setQueuesSelectedAwaiting] = useState([]);
  const [disable, setDisable] = useState(true);
  const [loading, setLoading] = useState(true);
  const [showSelector, setShowSelector] = useState(true);
  const [filterText, setFilterText] = useState('');

  const fetchQueuesLocalStorage = async () => {
    const storageQueues = await accessLocalStorage.getItemInKey('queues');
    if(storageQueues === null) return false;
    return storageQueues;
  };

  const getInitialQueues = async () => {
    try {
      setLoading(true);
      const dataUser = await accessLocalStorage.getUserLocalStorage();
      let { user: { queuesviewer, idtenant }} = dataUser;
      let receivedQueues = await exportSelectAllQueues();
      receivedQueues = scopeByTenant(receivedQueues, (queue) => queue.accountcodequeue, idtenant);
      const transformQueues = receivedQueues.map((queue) => queue.namequeue)
      const visibility = queuesviewer !== 'all' ? queuesviewer.split(',') : [];
      visibility.length > 0 ? setQueues(transformQueues.filter((queue) => {
        if(visibility.includes(queue)) return queue;
      })) : setQueues(transformQueues);

      const queueStorageExist = await fetchQueuesLocalStorage();

      if(queueStorageExist.length >= 1) {
        setQueues(queueStorageExist);
        setQueuesSelected(queueStorageExist);
        setShowSelector(false);
        setLoading(false);
        return queueStorageExist;
      }
      setLoading(false);

    } catch (error) {
      setLoading(false);
      return error;
    }
  };

  const deleteQueueScreem = async (data) => {
    const filterQueues = queues.filter((queue) => queue !== data);
    setQueuesSelected(filterQueues);
    setQueues(filterQueues);
    accessLocalStorage.setItemInKey('queues', filterQueues);

    if (filterQueues.length === 0) return window.location.reload(true);
    return getInitialQueues();
  };

  const handleClickUpdate = () => {
    if(queuesSelectedAwaiting.length < 1) return;
    accessLocalStorage.setItemInKey('queues', queuesSelectedAwaiting);
    setQueuesSelected(queuesSelectedAwaiting);
    setShowSelector(false);
    return getInitialQueues();
  };

  const handleChangeSelectedQueues = (element) => {
    setQueuesSelectedAwaiting((prevState) => {
      const onlineState = prevState.includes(element) ? [...prevState.filter((e) => e !== element)] : [...prevState, element];
      onlineState.length > 0 ? setDisable(false) : setDisable(true);
      return onlineState;
    });
  };

  const filteredQueues = queues.filter((queue) => {
    const searchText = filterText.toLowerCase();
    return queue.toLowerCase().includes(searchText);
  });

  useEffect(() => {
   let cancel = false;
    
   if (cancel) return;
   getInitialQueues();

   return () => {
     cancel = true
   };
  }, []);

  return (
    <div className="callcenter-container">
      <div className="callcenter-header">
        <div className="callcenter-title-wrapper">
          <svg className="callcenter-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
          </svg>
          <h1 className="callcenter-title">Call Center</h1>
          <p className="callcenter-subtitle">Monitoramento em tempo real</p>
        </div>
      </div>

      {loading ? (
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Carregando filas...</p>
        </div>
      ) : (
        <>
          {showSelector ? (
            <div name="select-queues" className="columns">
              <div className="queue-selector-card">
                <div className="queue-selector-header">
                  <svg className="queue-selector-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
                  </svg>
                  <h2 className="queue-selector-title">Selecione as Filas</h2>
                  <p className="queue-selector-description">Escolha as filas que deseja monitorar</p>
                </div>

                <div className="filter-section" style={{marginBottom: '1rem'}}>
                  <div className="filter-input-wrapper">
                    <svg className="filter-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                    <input
                      type="text"
                      className="filter-input"
                      placeholder="Filtrar filas..."
                      value={filterText}
                      onChange={(e) => setFilterText(e.target.value)}
                    />
                    {filterText && (
                      <button className="filter-clear" onClick={() => setFilterText('')}>
                        ×
                      </button>
                    )}
                  </div>
                  <div className="filter-results">
                    Exibindo {filteredQueues.length} de {queues.length} fila(s)
                  </div>
                </div>

                <div className="queue-checkbox-list">
                  {filteredQueues.map((queue) => (
                    <label className="queue-checkbox-item" key={queue}>
                      <input
                        type="checkbox"
                        value={queue}
                        className="queue-checkbox-input"
                        onChange={(e) => handleChangeSelectedQueues(e.target.value)}
                      />
                      <span className="queue-checkbox-custom"></span>
                      <span className="queue-checkbox-label">{queue}</span>
                    </label>
                  ))}
                </div>

                <div className="queue-selector-actions">
                  <button
                    className={`btn-filter ${disable ? 'disabled' : ''}`}
                    type="submit"
                    onClick={handleClickUpdate}
                    disabled={disable}
                  >
                    <svg className="btn-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
                    </svg>
                    <span>Aplicar Filtro</span>
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div name="list-queues" className="queues-list-container">
              {queuesSelected.map((queue) => (
                <QueueList key={queue} queueName={queue} queueRemove={deleteQueueScreem} />
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default QueueEvents;
